import script from "./media-viewer.vue?vue&type=script&setup=true&lang=js"
export * from "./media-viewer.vue?vue&type=script&setup=true&lang=js"

import "./media-viewer.vue?vue&type=style&index=0&id=109b482f&scoped=true&lang=css"
import "./media-viewer.vue?vue&type=style&index=1&id=109b482f&lang=css"

import exportComponent from "/home/dev.qpax-tcms.net/public_html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-109b482f"]])

export default __exports__